/**
 * Navigation History Store
 *
 * Tracks route history for the **native mobile app shell** (shopping, account, etc.).
 * Used by useNavigationGuards.js to maintain a navigation stack on Capacitor/native
 * platforms where there is no browser back button.
 *
 * ⚠️  NOT used by the return flow. The return flow has its own back-navigation system:
 *   - Conversation snapshots (conversationStore) for state restoration
 *   - item.routingHistory for analytics audit trail
 *   - restoreBackState() utility for unified back-navigation logic
 *
 * Consumers:
 *   - useNavigationGuards.js — pushes/pops routes during beforeEach (native mobile only)
 *   - ShoppingHeaderToolbar.vue — reads hasHistory to show/hide the back button
 */

export const useNavigationStore = defineStore('navigation', () => {
  const history = ref([])
  const lastPopped = ref(null)

  const hasHistory = computed(() => history.value.length > 1)
  const currentRoute = computed(() => {
    return history.value.slice(-1)[0]
  })
  const previousRoute = computed(() => {
    return history.value.length > 1 ? history.value.slice(-2)[0] : null
  })

  function clearHistory() {
    // $logger.debug('clearHistory')
    history.value = []
  }

  function appendHistory(newRoute) {
    // $logger.debug('appendHistory', newRoute)
    history.value.push(newRoute)
    // $logger.debug('history', history.value)
  }

  function popHistory() {
    lastPopped.value = history.value.pop()
    // $logger.debug('popHistory', lastPopped.value)
    // $logger.debug('history', history.value)
  }

  return {
    // STATE
    hasHistory,
    history,
    lastPopped,
    // GETTERS
    currentRoute,
    previousRoute,
    // ACTIONS
    appendHistory,
    clearHistory,
    popHistory,
  }
})
